export class Environment {
    public static isSocial() {
        return !Environment.isSite();
    }

    public static isSite() {
        return window.app.config.current_entry_point.includes('site');
    }

    public static isLanding() {
        return !!window.app.isLanding;
    }
}
